import BigNumber from "bignumber.js";

interface IProps {
  estimatedAmount: string;
  maxSlippage: string;
  fromCurrencyDecimals: number;
}

export const getMaxPayAmount = (props: IProps) => {
  const { estimatedAmount, maxSlippage, fromCurrencyDecimals } = props;

  if (!estimatedAmount || !maxSlippage) {
    return "-";
  }

  const estimatedAmountBN = new BigNumber(estimatedAmount);
  const maxSlippageBN = new BigNumber(maxSlippage);
  const oneBN = new BigNumber(1);

  const maxPayAmount = estimatedAmountBN
    .multipliedBy(oneBN.plus(maxSlippageBN))
    .decimalPlaces(fromCurrencyDecimals, 1)
    .toFixed()
    .toString();

  return maxPayAmount;
};
